import { render, staticRenderFns } from "./TruformeNewReturning.vue?vue&type=template&id=8235a612&scoped=true"
import script from "./TruformeNewReturning.vue?vue&type=script&lang=ts"
export * from "./TruformeNewReturning.vue?vue&type=script&lang=ts"
import style0 from "./TruformeNewReturning.vue?vue&type=style&index=0&id=8235a612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8235a612",
  null
  
)

export default component.exports